<template>
  <modal
    :header-text="headerText"
    :button-text="btnText"
    :width="widthWindow"
    :not-backdrop="true"
    @action="addCriticalEvents()"
    @close="close()"
  >
    <div
      v-if="isDelete"
      :class="$style.container"
    >
      {{ $t('settings.criticalEvents.deleteRection') }}
    </div>
    <div
      v-else
      :class="$style.containerBody"
    >
      <div :class="$style.inputContainer">
        <label>{{ $t('settings.criticalEvents.event') }}</label>
        <select
          v-model="selectedEvent"
          :class="$style.input"
        >
          <option
            v-for="option in getOptions('eventTypes')"
            :key="option.id"
            :value="option.id"
            :disabled="isEventUnavailable(option.id)"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
      <div :class="[$style.inputContainer, { [$style.inputDisabled]: !viewTextarea }]">
        <label>{{ $t('settings.criticalEvents.applyRuleTo') }}</label>
        <textarea
          v-model="eventValue"
          :disabled="!viewTextarea"
          :class="$style.textarea"
        />
      </div>

      <div :class="$style.inputContainer">
        <label>{{ $t('settings.criticalEvents.reaction') }}</label>
        <select
          v-model="selectedReaction"
          :class="$style.input"
        >
          <option
            v-for="option in getOptions('reactions')"
            :key="option.id"
            :value="option.id"
            :disabled="isReactionUnavailable(option.id)"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
      <div v-if="isCaptureReaction">
        <div :class="$style.inputContainer">
          {{
            selectedReaction === 0 ? $t('settings.criticalEvents.screenshots') : $t('settings.criticalEvents.webcam')
          }}
        </div>
        <div :class="$style.inputContainer">
          <label>{{ $t('settings.criticalEvents.count') }}</label>
          <input
            v-model="count"
            type="number"
            min="1"
            :class="[$style.input, $style.inputScreen]"
          >
        </div>

        <div :class="$style.inputContainer">
          <label>{{ $t('settings.criticalEvents.interval') }}</label>

          <div :class="$style.inputWrapper">
            <input
              v-model="interval"
              type="number"
              min="1"
              :class="[$style.input, $style.inputScreen]"
            >
            <div>
              {{ $t('global.sec') }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMessageReaction">
        <div :class="$style.inputContainer">
          {{ $t('settings.criticalEvents.message') }}
        </div>
        <input
          v-model="message"
          type="text"
          :class="$style.input"
        >
      </div>
      <div v-if="isPCReaction">
        <div :class="$style.inputContainer">
          PC
        </div>
        <div :class="$style.inputContainer">
          <label>{{ $t('settings.criticalEvents.delay') }}</label>
          <div :class="$style.inputWrapper">
            <input
              v-model="delay"
              type="number"
              min="1"
              :class="[$style.input, $style.inputScreen]"
            >
            <div>
              {{ $t('global.sec') }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="isRecordReaction">
        <div :class="$style.inputContainer">
          Webcam/microphone
        </div>
        <div :class="$style.inputContainer">
          <label>{{ $t('settings.criticalEvents.duration') }}</label>
          <div :class="$style.inputWrapper">
            <input
              v-model="duration"
              type="number"
              :class="[$style.input, $style.inputScreen]"
            >
            <div>
              {{ $t('global.sec') }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="isProgramReaction">
        <div :class="$style.inputContainer">
          {{ $t('settings.criticalEvents.program') }}
        </div>

        <div :class="$style.inputContainer">
          <label>{{ $t('settings.criticalEvents.launchApp') }}</label>
          <input
            v-model="launchApp"
            type="text"
            :class="$style.input"
          >
        </div>
        <div :class="$style.inputContainer">
          <label>{{ $t('settings.criticalEvents.launchOptions') }}</label>
          <input
            v-model="launchOptions"
            type="text"
            :class="$style.input"
          >
        </div>
      </div>
      <div v-if="isScriptReaction">
        <div :class="$style.inputContainer">
          Script
        </div>

        <textarea
          v-model="commandText"
          :class="$style.textarea"
        />
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/settings-modal.vue';

  const UNAVAILABLE_EVENT_TYPES = [4, 8, 9, 13, 14, 15, 16];
  const UNAVAILABLE_REACTIONS = [7];

  export default {
    components: { Modal },
    props: ['criticalEvents', 'event', 'isDelete'],
    data() {
      return {
        unavailableEventTypes: UNAVAILABLE_EVENT_TYPES,
        unavailableReactions: UNAVAILABLE_REACTIONS,
        selectedEvent: 0,
        selectedReaction: 0,
        eventValue: '',
        launchApp: '',
        launchOptions: '',
        count: 1,
        interval: 1,
        message: '',
        delay: 5,
        duration: 0,
        commandText: '',
      };
    },
    computed: {
      headerText() {
        if (this.isDelete) return this.$t('global.confirm');
        return this.event
          ? this.$t('settings.criticalEvents.editRection')
          : this.$t('settings.criticalEvents.addRection');
      },
      widthWindow() {
        if (this.isDelete) return 20;
        return 40;
      },
      btnText() {
        return this.isDelete ? this.$t('global.delete') : this.$t('global.save');
      },
      profileId() {
        return this.$store.getters['settings/profile'];
      },
      viewTextarea() {
        return [3, 5, 6].includes(this.selectedEvent);
      },
      isCaptureReaction() {
        return [0, 4].includes(this.selectedReaction);
      },
      isPCReaction() {
        return [2, 3].includes(this.selectedReaction);
      },
      isRecordReaction() {
        return [5, 6].includes(this.selectedReaction);
      },
      isMessageReaction() {
        return this.selectedReaction === 1;
      },
      isProgramReaction() {
        return this.selectedReaction === 8;
      },
      isScriptReaction() {
        return this.selectedReaction === 9;
      },
    },
    watch: {
      event: {
        handler(newEvent) {
          if (newEvent) {
            this.populateEventData(newEvent);
          }
        },
        immediate: true,
      },
    },
    methods: {
      isEventUnavailable(id) {
        return this.unavailableEventTypes.includes(id);
      },
      isReactionUnavailable(id) {
        return this.unavailableReactions.includes(id);
      },
      populateEventData(event) {
        if (!event) return;

        this.selectedEvent = event.eventType ?? 0;
        this.selectedReaction = event.reaction ?? 0;
        this.eventValue = event.eventValue ?? '';

        if (event.commentData) {
          this.count = Number(event.commentData.count) || 1;
          this.interval = Number(event.commentData.interval) || 1;
          this.message = event.commentData.message_text ?? '';
          this.delay = Number(event.commentData.delay) || 5;
          this.duration = Number(event.commentData.duration) || 0;
          this.launchApp = event.commentData.application_path ?? '';
          this.launchOptions = event.commentData.arguments ?? '';
          this.commandText = event.commentData.command_text ?? '';
        }
      },
      getOptions(name) {
        const data = this.$t(`settings.criticalEvents.${name}`);
        return Object.keys(data).map((key) => ({
          id: Number(key),
          name: this.$t(`settings.criticalEvents.${name}.${key}`),
        }));
      },
      close() {
        this.$emit('close');
      },
      buildEventData() {
        switch (this.selectedEvent) {
          case 3:
            return {
              exename: this.eventValue,
            };
          case 5:
            return {
              url: this.eventValue,
            };
          case 6:
            return {
              key: this.eventValue,
            };
          default:
            return {};
        }
      },
      buildComment() {
        switch (this.selectedReaction) {
          case 0:
          case 4:
            return {
              interval: String(this.interval),
              count: String(this.count),
            };
          case 1:
            return {
              message_text: this.message,
            };
          case 2:
          case 3:
            return {
              delay: String(this.delay),
            };
          case 5:
          case 6:
            return {
              duration: String(this.duration),
            };
          case 8:
            return {
              application_path: this.launchApp,
              arguments: this.launchOptions,
            };
          case 9:
            return {
              command_text: this.commandText,
            };
          case 7:
          case 10:
          case 11:
          default:
            return {};
        }
      },
      getCommentValue(commentData) {
        switch (this.selectedReaction) {
          case 1:
            return commentData.message_text ?? '';
          case 8:
            return commentData.application_path ?? '';
          default:
            return Object.keys(commentData).length ? JSON.stringify(commentData) : '';
        }
      },
      async addCriticalEvents() {
        const eventData = this.buildEventData();
        const commentData = this.buildComment();

        const currentEvent = {
          id: this.event?.id || `n${this.criticalEvents.length}`,
          eventType: this.selectedEvent,
          eventValue: this.eventValue,
          reaction: this.selectedReaction,
          commentData,
          commentValue: this.getCommentValue(commentData),
          eventData,
        };

        let events;
        if (this.isDelete && this.event) {
          events = this.criticalEvents.filter((event) => event.id !== this.event.id);
        } else if (!this.isDelete && this.event) {
          events = this.criticalEvents.map((event) => (event.id === this.event.id ? currentEvent : event));
        } else {
          events = [...this.criticalEvents, currentEvent];
        }

        this.$emit('update', events);
      },
    },
  };
</script>

<style lang="scss" module>
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .containerBody {
    padding: 10px;
  }
  .inputContainer {
    display: grid;
    grid-template-columns: 180px 1fr;
    align-items: center;
    gap: 10px;
  }

  .input,
  .textarea,
  .inputWrapper {
    width: 100%;
  }
  .textarea,
  .input {
    margin: 5px;
    width: 100%;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
  }
  .inputScreen {
    width: 60px;
  }
  .textarea {
    height: 60px;
    resize: vertical;
  }
  .inputDisabled {
    opacity: 0.2;
  }

  .inputWrapper {
    display: flex;
    gap: 2px;
    align-items: center;
  }

  .button {
    margin: 5px;
    height: 30px;
    cursor: pointer;
    width: 150px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
</style>
